





































































































































































































































































































































































































































































































































































































import { Component, Mixins, Watch } from 'vue-property-decorator';
import {
  Alert,
  Button,
  Card,
  Checkbox,
  Form,
  FormItem,
  Option,
  Radio,
  RadioGroup,
  Select
} from 'element-ui';
import NullableInput from '@/components/element-ui/NullableInput.vue';
import UtcDatePicker from '@/components/element-ui/UtcDatePicker.vue';
import NaccsContact from '@/components/shipment/NaccsContact.vue';
import {
  naccsDeclarationOptions,
  naccsDueDateExtensionOptions,
  naccsEvaluationOptions,
  naccsImportRegulationCodeOptions,
  naccsInsuranceOptions,
  naccsInvoiceOptions,
  naccsPaymentMethodOptions,
  naccsTradingType1Options,
  naccsTradingType2Options,
  naccsTradingType3Options
} from '@/constants/Naccs';
import currencyOptions from '@/constants/currencyOptions';
import places from '@/mixins/placeOptions.ts';

// gql
import fetchNaccsDetailsQuery from '@/graphql/queries/shipment/FetchNaccsDetails.gql';

import { naccsService } from '@/services/NaccsService';

import { getUserToken } from '@/utilities/tokenTools';

import get from 'lodash/get';

import {
  BankAccountFields,
  CustomerRoleEnum,
  NaccsDeclarationTypeEnum,
  NaccsDueDateExtensionTypeEnum,
  NaccsIdaFields,
  NaccsIdaInput,
  NaccsImportRegulationCodeEnum,
  NaccsInsuranceTypeEnum,
  NaccsInvoiceTypeEnum,
  NaccsPaymentMethodEnum,
  PortTypeEnum,
  ShipmentFields,
  TransportationTypeEnum
} from '@/types/graphql/schemaTypes';

@Component({
  apollo: {
    ida: {
      query: fetchNaccsDetailsQuery,
      prefetch: true,
      variables() {
        return {
          shipmentArgs: {
            shipmentId: this.$route.params.id
          }
        };
      },
      update(data) {
        this.shipment = data.shipments[0];
        return get(data, 'shipments[0].naccsDocument.ida', null);
      },
      fetchPolicy: 'cache-and-network'
    }
  },
  components: {
    NaccsContact,
    UtcDatePicker,
    'el-alert': Alert,
    'el-button': Button,
    'el-card': Card,
    'el-checkbox': Checkbox,
    'el-form': Form,
    'el-form-item': FormItem,
    'el-input': NullableInput,
    'el-option': Option,
    'el-radio': Radio,
    'el-radio-group': RadioGroup,
    'el-select': Select
  }
})
export default class Naccs extends Mixins(places) {
  private consigneeIsCustomer = false;
  private editing = false;
  private loading = false;

  private ida: NaccsIdaFields | null = null;
  private shipment: ShipmentFields | null = null;

  // places mixin option
  placeTypes = [PortTypeEnum.bonded_area];
  public readonly transportationType: TransportationTypeEnum = TransportationTypeEnum.any;

  private readonly CustomerRoleEnum = CustomerRoleEnum;
  private readonly NaccsPaymentMethodEnum = NaccsPaymentMethodEnum;
  private readonly TransportationTypeEnum = TransportationTypeEnum;

  private readonly currencyOptions = currencyOptions();
  private readonly naccsDeclarationOptions = naccsDeclarationOptions();
  private readonly naccsDueDateExtensionOptions = naccsDueDateExtensionOptions();
  private readonly naccsEvaluationOptions = naccsEvaluationOptions();
  private readonly naccsInsuranceOptions = naccsInsuranceOptions();
  private readonly naccsInvoiceOptions = naccsInvoiceOptions();
  private readonly naccsPaymentMethodOptions = naccsPaymentMethodOptions();
  private readonly naccsTradingType1Options = naccsTradingType1Options();
  private readonly naccsTradingType2Options = naccsTradingType2Options();
  private readonly naccsTradingType3Options = naccsTradingType3Options();
  private readonly naccsImportRegulationCodeOptions = naccsImportRegulationCodeOptions();

  private idaInput: NaccsIdaInput = { // ⚠️ DO NOT REORDER
    declarationType: NaccsDeclarationTypeEnum.C, // 3
    customsApplicationDate: null, // 9
    consignee: { // 10
      address: {
        city: null,
        countryCode: null,
        line1: null,
        line2: null,
        prefecture: null,
        postalCode: null
      },
      name: null,
      normalizedName: null,
      phoneNumber: null
    },
    bondedArea: null, // 15
    shipperConsigneeStandardCode: null, // 10-1
    shipper: { // 19
      address: {
        city: null,
        countryCode: null,
        line1: null,
        line2: null,
        prefecture: null,
        postalCode: null
      },
      name: null,
      normalizedName: null,
      phoneNumber: null
    },
    blNumber: Array(1), // 22
    awbNumber: null, // 27
    mawbNumber: null, // 28
    tradingType: 518, // 38
    otherRegulations: Array(5).fill(null), // 45
    importCertificates: [{ code: '', number: '' }], // 50
    invoiceNumber: get(this.shipment, 'invoiceNumber', null), // 62
    invoiceType: null, // 63
    invoiceCurrency: null,
    invoicePrice: null,
    insuranceType: null, // 65
    insuranceCurrency: null,
    insurancePrice: null,
    evaluation: null, // 66
    existingAssessmentNumbers: Array(1), // 67
    dueDateExtensionType: null, // 75
    paymentMethod: null, // 77
    remarkFromShipper: null, // 82
    shipperSectionCode: null, // 83
    shipperReferenceNumber: null // 84
  };

  private tradingType1 = '5'; // default value
  private tradingType2 = '1'; // default value
  private tradingType3 = '8'; // default value

  private defaultData(): NaccsIdaInput {
    return {
      declarationType: NaccsDeclarationTypeEnum.C, // 3
      customsApplicationDate: null, // 9
      consignee: null, // 10
      bondedArea: null, // 15
      shipperConsigneeStandardCode: null, // 10-1
      shipper: null, // 19
      blNumber: Array(1), // 22
      awbNumber: null, // 27
      mawbNumber: null, // 28
      tradingType: 518, // 38
      otherRegulations: Array(5).fill(null), // 45
      importCertificates: [{ code: '', number: '' }], // 50
      invoiceNumber: get(this.shipment, 'invoiceNumber', null), // 62
      invoiceType: null, // 63
      invoiceCurrency: 'JPY',
      invoicePrice: null,
      insuranceType: null, // 65
      insuranceCurrency: 'JPY',
      insurancePrice: null,
      evaluation: null, // 66
      existingAssessmentNumbers: Array(1), // 67
      dueDateExtensionType: null, // 75
      paymentMethod: null, // 77
      remarkFromShipper: null, // 82
      shipperSectionCode: null, // 83
      shipperReferenceNumber: null // 84
    };
  }

  private downloadIda() {
    const url = `/shipments/${this.$route.params.id}/naccs/ida.txt`;
    const host = process.env.VUE_APP_API_HOST;
    const idaLink = host + url;

    return `${idaLink}?token=${getUserToken()}&role=operator`;
  }

  private setEditMode() {
    this.editing = true;
    if (!this.ida) {
      this.idaInput = this.defaultData();
      return;
    }

    this.idaInput = {
      declarationType: this.ida.declarationType || NaccsDeclarationTypeEnum.C, // 3
      customsApplicationDate: this.ida.customsApplicationDate || null, // 9
      consignee: { // 10
        address: {
          city: get(this.ida, 'consignee.address.city', null),
          countryCode: get(this.ida, 'consignee.address.country.unLocode', null),
          line1: get(this.ida, 'consignee.address.line1', null),
          line2: get(this.ida, 'consignee.address.line2', null),
          prefecture: get(this.ida, 'consignee.address.prefecture', null),
          postalCode: get(this.ida, 'consignee.address.postalCode', null)
        },
        name: get(this.ida, 'consignee.name', null),
        normalizedName: get(this.ida, 'consignee.normalizedName', null),
        phoneNumber: get(this.ida, 'consignee.phoneNumber', null)
      },
      bondedArea: this.ida.bondedArea || null, // 15
      shipperConsigneeStandardCode: this.ida.shipperConsigneeStandardCode || null, // 10-1
      shipper: { // 19
        address: {
          city: get(this.ida, 'shipper.address.city', null),
          countryCode: get(this.ida, 'shipper.address.country.unLocode', null),
          line1: get(this.ida, 'shipper.address.line1', null),
          line2: get(this.ida, 'shipper.address.line2', null),
          prefecture: get(this.ida, 'shipper.address.prefecture', null),
          postalCode: get(this.ida, 'shipper.address.postalCode', null)
        },
        name: get(this.ida, 'shipper.name', null),
        normalizedName: get(this.ida, 'shipper.normalizedName', null),
        phoneNumber: get(this.ida, 'shipper.phoneNumber', null)
      },
      blNumber: this.ida.blNumber || Array(1), // 22
      awbNumber: this.ida.awbNumber || null, // 27
      mawbNumber: this.ida.mawbNumber || null, // 28
      tradingType: this.ida.tradingType || 518, // 38
      otherRegulations: this.ida.otherRegulations || Array(5).fill(null), // 45
      importCertificates: get(
        this.ida,
        'importCertificates',
        [{ code: null, number: null }]
      ), // 50
      invoiceNumber: this.ida.invoiceNumber || get(this.shipment, 'invoiceNumber', null), // 62
      invoiceType: this.ida.invoiceType || null, // 63
      invoiceCurrency: this.ida.invoiceCurrency || 'JPY',
      invoicePrice: this.ida.invoicePrice || null,
      insuranceType: this.ida.insuranceType || null, // 65
      insuranceCurrency: this.ida.insuranceCurrency || 'JPY',
      insurancePrice: this.ida.insurancePrice || null,
      evaluation: this.ida.evaluation || null, // 66
      existingAssessmentNumbers: this.ida.existingAssessmentNumbers || Array(1), // 67
      dueDateExtensionType: this.ida.dueDateExtensionType || null, // 75
      paymentMethod: this.ida.paymentMethod || null, // 77
      remarkFromShipper: this.ida.remarkFromShipper || null, // 82
      shipperSectionCode: this.ida.shipperSectionCode || null, // 83
      shipperReferenceNumber: this.ida.shipperReferenceNumber || null // 84
    };
    this.tradingType1 = this.ida.tradingType ? this.ida.tradingType.toString().split('')[0] : '5';
    this.tradingType2 = this.ida.tradingType ? this.ida.tradingType.toString().split('')[1] : '1';
    this.tradingType3 = this.ida.tradingType ? this.ida.tradingType.toString().split('')[2] : '8';
  }

  private setTradingType() {
    this.idaInput.tradingType = parseInt(
      `${this.tradingType1}${this.tradingType2}${this.tradingType3}`,
      10
    );
  }

  private async submit() {
    this.loading = true;
    try {
      const response = await naccsService.updateNaccsIda(
        this.$route.params.id,
        this.idaInput
      );

      if (response.data && this.shipment && this.shipment.naccsDocument) {
        this.editing = false;
        this.ida = (response.data as any & {updateNaccsIda: NaccsIdaFields | null}).updateNaccsIda;
        this.$store.dispatch('Alert/addAlert', {
          type: 'success',
          message: this.$t('success.updated'),
          time: 2000
        });
      }
    } catch (e) {
      this.$store.dispatch('Alert/addAlert', {
        type: 'error',
        message: this.$t('error.push'),
        time: 2000
      });
    } finally {
      this.loading = false;
    }
  }

  get isExport() {
    return (this.shipment && this.shipment.customerRole === CustomerRoleEnum.seller) || false;
  }
}
